import React from 'react';
import { usePaymentStatus } from '../../hooks/usePaymentStatus';
import { Service } from '../../models/Service';

/**
 * Small payment badge for schedule view
 * Shows payment status for individual appointments
 */
const AppointmentPaymentBadge = ({ appointment, isMobile, isWeeklyMobileView }) => {
  const { paymentStatus } = usePaymentStatus(appointment?.id);

  // Hide in mobile weekly view
  if (isMobile && isWeeklyMobileView) {
    return null;
  }

  // Show "paid" badge if either is_paid flag is true OR payment status is completed
  const isPaid = appointment.is_paid || paymentStatus === 'completed';

  // Don't show any payment badge for no_show_justified appointments
  if (appointment.status === 'no_show_justified') {
    return null;
  }

  // Don't show payment badge for services that don't require payment (e.g., breaks, blocked time)
  if (Service.getServicesWithoutPayment().includes(appointment.service_name)) {
    return null;
  }

  if (isPaid) {
    return (
      <div className="absolute bottom-[1px] left-1">
        <div className="bg-green-100 text-green-800 px-1 rounded-full py-0 text-[8px] font-medium border border-green-200">
          ✓ שולם
        </div>
      </div>
    );
  }

  // Show "unpaid" badge
  return (
    <div className="absolute bottom-[1px] left-1">
      <div className="bg-red-100 text-red-800 px-1 rounded-full py-0 text-[8px] font-medium border border-red-300">
        ✗ טרם שולם
      </div>
    </div>
  );
};

export default AppointmentPaymentBadge;
